<wlm-popup-wrapper
  [titleKey]="T_SCOPE + '.title'"
  [showCloseButton]="true"
  [actionsContainerClass]="'worpskace-form-actions-container'"
  (popupClose)="cancel($event)"
>
  <ng-container popup-content>
    <div *ngIf="configuration" class="connect-form-container">
      <div class="connect-form-margin"></div>
      <tc-master-operator-workspace-form
        class="connect-form-content"
        [masterOperatorConnectItemSettings]="configuration"
        [showSubtitle]="false"
        (isValid)="onValidChanged($event)"
        (valueChanges)="onConfigured($event)"
      ></tc-master-operator-workspace-form>
      <div class="connect-form-margin"></div>
    </div>
  </ng-container>
  <ng-container popup-actions>
    <button
      mat-raised-button
      class="wtr-action-button-primary"
      onclick="this.blur()"
      (click)="connect()"
      [disabled]="!isValid"
    >
      {{ T_SCOPE + '.buttons.connect' | translate }}
    </button>
  </ng-container>
</wlm-popup-wrapper>
